import React, { useState, useRef, useEffect, useCallback } from "react";
import 'ag-grid-enterprise';
import { useNavigate, useParams } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import moment from 'moment';
import AgGridTable from "../../../utilities/AgGridTable";

const Asset = () => {

    const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.assets}`;
    const perPage = 10;
    const params = useParams();
    const [rowData, setRowData] = useState();
    const [error, setError] = useState("")
    const gridRef = useRef();
    const handleDateFormat = (props) => {
        return props.value && moment(props.value).format('DD-MM-YYYY')
    }
    const [columnDefs, setColumnDefs] = useState([
        { field: 'assetSrlNum', enableRowGroup: true, },
        { field: 'assetName', enableRowGroup: true, },
        { field: 'handOverDate', enableRowGroup: true, cellRenderer : handleDateFormat },
        { field: 'expiryDate', enableRowGroup: true, cellRenderer : handleDateFormat },
        { field: 'assetStatus', enableRowGroup: true, },
        { field: 'approvalStatus', enableRowGroup: true, },
        { field: 'condition', enableRowGroup: true, },
        { field: 'purchasePrice', enableRowGroup: true, },
    ]);

    const getAssets = async () => {
        try {
            const res = await OAuthService.getList(url + '?sort=cityName,asc&size=1000');
            const assets = res.data;
            console.log('assets', assets);
            const employeeAssets = assets.filter((asset)=> asset.employeeId == params.id);
            console.log('employeeAssets', employeeAssets);
            setRowData(employeeAssets);
        } catch (error) {
            setError(error.message);
            console.log(error);
        }
    }
    useEffect(() => {
      if(params.id){
        getAssets();
      }
    
    }, [params.id])
    


    return (
        <div style={{ height: '500px' }}>
            <AgGridTable
                rowData={rowData}
                columnDefs={columnDefs}
                gridRef={gridRef}
                paginationPageSize={perPage}
                cacheBlockSize={perPage}
                editable={false}
                saveGridStateName={'assets-tab'}
            />
        </div>
    )
}

export default Asset